import { render } from "./CardComponent.vue?vue&type=template&id=7dce6b46&scoped=true&ts=true"
import script from "./CardComponent.vue?vue&type=script&lang=ts"
export * from "./CardComponent.vue?vue&type=script&lang=ts"

import "./CardComponent.vue?vue&type=style&index=0&id=7dce6b46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dce6b46"]])

export default __exports__